import { DateUtil } from '@/utils'

/**
 * 车轮战表单日期展示：2025-06-01 [周日]
 */
export function formatWheelBattleDateOnly(dateVal) {
  if (!dateVal) {
    return ''
  }
  var datePart = DateUtil.parseDateTime(dateVal, '{y}-{m}-{d}')
  var weekPart = DateUtil.parseDateTime(dateVal, '{a}')
  if (!datePart) {
    return ''
  }
  return datePart + (weekPart ? ' [周' + weekPart + ']' : '')
}

/**
 * 车轮战表单时间展示：17:20
 */
export function formatWheelBattleTimeOnly(dateVal) {
  if (!dateVal) {
    return ''
  }
  return DateUtil.parseDateTime(dateVal, '{h}:{i}') || ''
}

/**
 * 车轮战表单时间展示：2025-06-01 [周日] 17:20
 * @param {Date|string|number|null} dateVal
 * @returns {string}
 */
export function formatWheelBattleDateTime(dateVal) {
  if (!dateVal) {
    return ''
  }
  var datePart = formatWheelBattleDateOnly(dateVal)
  var timePart = formatWheelBattleTimeOnly(dateVal)
  if (!datePart || !timePart) {
    return datePart || timePart || ''
  }
  return datePart + ' ' + timePart
}
